var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardLayout',[_c('ResentLinkCardHeader',{attrs:{"card-icon":_vm.cardIcon,"card-title":_vm.cardTitle,"card-subtitle":_vm.cardSubtitle}}),_c('ResentLinkCardContent',{attrs:{"email":_vm.email}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }